import customerInstance from '../instance'

const deleteDeliveryConfig = (id) => {
  return customerInstance.delete('/delivery-configs/' + id)
}

export default deleteDeliveryConfig
